// extracted by mini-css-extract-plugin
export default {"container":"F9IXUQvm","skeleton":"yLUpULyz"};